var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { attr, listen, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { ESLMediaQuery } from '@exadel/esl/modules/esl-media-query/core';
import { UIPPlugin } from '../../core/base/plugin';
import { UIPSnippetsIcon } from '../snippets-list/snippets.icon';
/**
 * Snippets {@link UIPPlugin} custom element definition
 * Container for {@link UIPSnippetsList} element
 */
export class UIPSnippets extends UIPPlugin {
    /** @returns true if dropdown mode should be active */
    get isDropdown() {
        return ESLMediaQuery.for(this.dropdownView).matches;
    }
    /** Builds inner {@link UIPSnippetsTitle} */
    get $title() {
        return React.createElement("uip-snippets-title", null);
    }
    /** Builds trigger area for dropdown mode */
    get $trigger() {
        return (React.createElement("esl-trigger", { "active-class": "open", className: "uip-snippets-trigger", target: "::next" },
            React.createElement(UIPSnippetsIcon, null),
            this.$title));
    }
    /** Builds dropdown/main area */
    get $toggleable() {
        return (React.createElement("esl-toggleable", { class: "uip-snippets-dropdown", "close-on-outside-action": true, "close-on-esc": true, "close-on": "li" },
            React.createElement("uip-snippets-list", null),
            React.createElement("esl-scrollbar", { class: "uip-snippets-scroll", target: "::prev::child" })));
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        if ((_a = this.$root) === null || _a === void 0 ? void 0 : _a.ready)
            this._onRootReady();
    }
    attributeChangedCallback(attrName, oldVal, newVal) {
        super.attributeChangedCallback(attrName, oldVal, newVal);
        if (attrName === 'dropdown-view') {
            this.$$off(this._onBreakpointChange);
            this.$$on(this._onBreakpointChange);
            this._onBreakpointChange();
        }
    }
    /** Renders {@link UIPSnippetsList} element */
    _renderSnippetsList() {
        var _a;
        switch ((_a = this.model) === null || _a === void 0 ? void 0 : _a.snippets.length) {
            case 0: return;
            case 1:
                this.prepend(this.$title);
                break;
            default:
                this.prepend(this.$trigger, this.$toggleable);
                break;
        }
    }
    _onRootReady() {
        this._renderSnippetsList();
        this._onBreakpointChange();
    }
    _onBreakpointChange() {
        const isDropdown = ESLMediaQuery.for(this.dropdownView).matches;
        // Toggleable is open in tabs mode
        this.$toggleable.toggle(!isDropdown);
        this.$$attr('view', isDropdown ? 'dropdown' : 'tabs');
    }
    _onBeforeHide(e) {
        // Prevent hide toggleable in inactive state (tabs)
        if (e.target === this.$toggleable && !this.isDropdown)
            e.preventDefault();
    }
}
UIPSnippets.is = 'uip-snippets';
UIPSnippets.observedAttributes = ['dropdown-view', ...UIPPlugin.observedAttributes];
__decorate([
    attr({ defaultValue: 'not all' })
], UIPSnippets.prototype, "dropdownView", void 0);
__decorate([
    memoize()
], UIPSnippets.prototype, "$title", null);
__decorate([
    memoize()
], UIPSnippets.prototype, "$trigger", null);
__decorate([
    memoize()
], UIPSnippets.prototype, "$toggleable", null);
__decorate([
    listen({ event: 'uip:root:ready', target: ($this) => $this.$root })
], UIPSnippets.prototype, "_onRootReady", null);
__decorate([
    listen({
        event: 'change',
        target: (snippets) => ESLMediaQuery.for(snippets.dropdownView)
    })
], UIPSnippets.prototype, "_onBreakpointChange", null);
__decorate([
    listen('esl:before:hide')
], UIPSnippets.prototype, "_onBeforeHide", null);
